export const name_validation_uk = {
  name: "name",
  label: "name",
  type: "text",
  id: "name",
  placeholder: "Ім'я",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "обов'язкове",
    },
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
  },
};

export const from_hidden_validation_uk = {
  name: "form",
  label: "form",
  type: "hidden",
  id: "form",
  placeholder: "",
  className: "",
  value: "Footer Form",
  validation: {
    required: {
      value: true,
      message: "обов'язкове",
    },
  },
};

export const to_hidden_validation_uk = {
  name: "to",
  label: "to",
  type: "hidden",
  id: "to",
  placeholder: "",
  className: "",
  value: "web@twid.marketing",
  validation: {
    required: {
      value: true,
      message: "обов'язкове",
    },
  },
};

export const company_validation_uk = {
  name: "company",
  label: "company",
  type: "text",
  id: "company",
  placeholder: "Компанія",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: false,
      message: "обов'язкове",
    },
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
  },
};

export const message_validation_uk = {
  name: "message",
  label: "message",
  type: "textarea",
  multiline: true,
  id: "message",
  placeholder: "Повідомлення",
  className: "",
  validation: {
    required: {
      value: true,
      message: "обов'язкове",
    },
    maxLength: {
      value: 200,
      message: "200 characters max",
    },
  },
};

export const password_validation_uk = {
  name: "password",
  label: "password",
  type: "password",
  id: "password",
  placeholder: "type password ...",
  validation: {
    required: {
      value: true,
      message: "обов'язкове",
    },
    minLength: {
      value: 6,
      message: "min 6 characters",
    },
  },
};

export const num_validation_uk = {
  name: "num",
  label: "number",
  type: "number",
  id: "num",
  placeholder: "write a random number",
  validation: {
    required: {
      value: true,
      message: "обов'язкове",
    },
  },
};

export const email_validation_uk = {
  name: "email",
  label: "email address",
  type: "email",
  id: "email",
  placeholder: "E-mail",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "обов'язкове",
    },
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: "помилковий формат",
    },
  },
};
